<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-11 09:55:13
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-06-07 14:35:47
-->
<template>
  <div class="innovative innovative-acculv" :class="{textj: language != 'en'}" ref="acculv">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.acculv.title')"></div>
    </div>
    <div class="p-t-60 overhid">
      <div class="innovative-container">
        <div class="innovative-wrap-item flex p-b-150" :class="{align_items_center: language != 'en'}">
          <div class="flex_1">
            <img class="" :src="$t('product.acculv.list[0].img')" alt="" srcset="">
          </div>
          <div class="flex_1 p-l-80">
            <div class="innovative-item-title" v-html="$t('product.acculv.list[0].title')"></div>
            <div class="p-t-15 textj">
              <p :class="{'p-b-30': index < $t('product.acculv.list[0].des').length - 1}" v-for="item, index in $t('product.acculv.list[0].des')" :key="index" v-html="item"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="innovative-wrap-item p-t-0 posrel acculv-characteristics">
        <img v-if="language != 'en'" class="wh100" :src="$t('product.acculv.list[1].img')" alt="" srcset="">
        <div class="t-0 wh100 innovative-container p-t-50 p-b-50" :class="{posabs: language != 'en'}">
          <div class="innovative-characteristics trans-list wh100 flex flex_col">
            <div class="innovative-item-title p-l-15" v-html="$t('product.acculv.list[1].title')"></div>
            <div class="flex_1 flex flex_col justify_content_center">
              <div class="flex p-t-30">
                <div :class="['flex_1 flex flex_col align_items_center']" v-for="item, index in $t('product.acculv.list[1].des')" :key="index" :style="language == 'en' ? 'padding: 0 4%;' : 'padding: 0 8%;'">
                  <div :class="['flex flex_col align_items_center', index == 1 ? 'p-r-40' : '']">
                    <div style="height: 65px;">
                      <img class="" :src="item.img" alt="" srcset="">
                    </div>
                    <template v-if="language == 'en'">
                      <div v-if="clientWidth <= 1660 || clientWidth >= 2370" class="innovative-wrap-item-title textc fz-22 p-b-20 p-t-15" v-html="item.title.join(' ')"></div>
                      <div v-else class="innovative-wrap-item-title textc fz-22 p-b-20 p-t-15">
                        <p v-for="$item, $index in item.title" :key="$index" v-html="$item"></p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="innovative-wrap-item-title textc fz-22 p-b-20 p-t-15">
                        <p v-for="$item, $index in item.title" :key="$index" v-html="$item"></p>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="flex">
                <div :class="['flex_1 flex flex_col align_items_center']" v-for="item, index in $t('product.acculv.list[1].des')" :key="index" :style="language == 'en' ? 'padding: 0 4%;' : 'padding: 0 8%;'">
                  <div>
                    <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="acculv-advantages innovative-wrap-item">
        <div class="innovative-container">
          <div class="innovative-acculv-m-h innovative-characteristics trans-list">
            <div class="innovative-item-title p-l-15" style="" v-html="$t('product.acculv.list[2].title')"></div>
            <div :class="[clientWidth > 1440 ? 'p-l-40' : 'p-l-10']">
              <el-row :gutter="clientWidth > 1440 && language != 'en' ? 90 : 40" class="flex flex_wrap p-t-40">
                <el-col class="flex innovative-acculv-m-h-item" :span="12" v-for="item, index in $t('product.acculv.list[2].des')" :key="index">
                  <div class="innovative-acculv-m-h-img textc">
                    <img :src="item.img" alt="" srcset="" />
                  </div>
                  <div class="p-l-42 flex_1">
                    <div class="innovative-wrap-item-title fz-24 p-b-28" v-html="item.title"></div>
                    <div class="">
                      <p class="innovative-characteristics-item p-b-15" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="p-t-43 p-b-50 p-l-62 p-r-48">
            <img class="wid100" :src="$t('product.acculv.list[2].img')" alt="" srcset="">
            <p class="textc fz-20" v-html="$t('product.acculv.list[2].imgDes')"></p>
          </div>
        </div>
      </div>
      <div class="innovative-container">
        <div class="innovative-wrap-item p-t-50 article">
          <div class="innovative-item-title p-l-15" v-html="$t('product.acculv.article.title')"></div>
          <div class="p-t-15">
            <p class="p-t-15" v-for="item, index in $t('product.acculv.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['language', 'clientWidth'])
  }
}
</script>

<style lang="less">
@import "~@/styles/pc/products.less";
</style>

<style lang="less" scoped>
.pc .innovative-acculv {
  padding-bottom: 50PX;
  .innovative-characteristics {
    padding: 50PX 65PX;
  }
  .acculv-advantages {
    background: #F8FBFF;
    padding: 50PX 0;
  }
  .innovative-acculv-m-h {
    background: #FFFFFF;
    box-shadow: 0PX 4PX 12PX 4PX rgba(81, 170, 255, 0.1);
    padding: 55PX 62PX 0 62PX;
    font-size: 18PX;
    .innovative-acculv-m-h-item {
      padding: 58PX 45PX;
      &:nth-child(2n + 1) {
        padding-bottom: 0;
      }
    }
    .innovative-acculv-m-h-img {
      width: 120PX;
    }
  }
}
.pc.en .innovative-acculv {
  .acculv-characteristics {
    background-image: url('~@/assets/images/innovate/AccuLV/2.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1600PX) {
  .pc.zh .innovative-acculv {
    .acculv-characteristics {
      height: 580PX;
    }
    .innovative-acculv-m-h {
      .innovative-acculv-m-h-item {
        padding: 38PX 35PX;
      }
      .innovative-acculv-m-h-img {
        width: 80PX;
      }
    }
  }
}
</style>
